import { ComboBox, Text } from '@forecast-it/design-system';
import React from 'react';
const AvaCustomFieldRefDropdown = ({ avaRef, existingAvaRefs, avaRefItems, setAvaRef, }) => {
    return (React.createElement(ComboBox, { value: avaRef, defaultSelectedKey: "0", label: "Advanced Analytics Reference", items: avaRefItems, onChange: selectedValue => {
            setAvaRef(selectedValue);
        }, disabledKeys: existingAvaRefs.map(String) }, (item) => (React.createElement(ComboBox.Item, { textValue: item.value },
        React.createElement(Text, { color: item.disabled ? 'disabled' : 'main' }, item.value)))));
};
export default AvaCustomFieldRefDropdown;
